import { FunctionComponent } from 'react';
import { TabCronProp } from '@/types/cron';
import { INPUT_FIELD_CLASSNAME } from '@/constants/classname/classname';

const HourlyCron: FunctionComponent<TabCronProp> = (props) => {
    const onHourChange = (e: { target: { value: string } }) => {
        if (!props.disabled && ((parseInt(e.target.value) > 0 && parseInt(e.target.value) < 24) || e.target.value === '')) {
            const val = ['0', '0', '*', '*', '*', '?', '*'];
            val[1] = props.value[1];
            val[2] = e.target.value ? `0/${e.target.value}` : e.target.value;
            val[3] = '1/1';
            props.onChange(val)
        }
    }
    const onMinuteChange = (e: { target: { value: string } }) => {
        if (!props.disabled && ((parseInt(e.target.value) > 0 && parseInt(e.target.value) < 60) || e.target.value === '')) {
            const val = ['0', '0', '*', '*', '*', '?', '*'];
            val[1] = e.target.value
            val[2] = props.value[2];
            val[3] = '1/1';
            props.onChange(val)
        }
    }

    return (
        <div className="hour py-4">
            <div className='text-left font-semibold text-base mb-1'>{props.translate('Every')}</div>
            <div className='w-full flex flex-row items-center'>
                <input
                    className={INPUT_FIELD_CLASSNAME + ' w-[120px]'}
                    disabled={props.disabled}
                    type="Number"
                    onChange={onHourChange}
                    min={0}
                    max={23}
                    value={props.value[2]?.split('/')[1] ? props.value[2].split('/')[1] : props.value[2]}
                />
                <div className='text-base ml-2'>{props.translate('hour')}</div>
                <div className='mx-3' />
                <input
                    className={INPUT_FIELD_CLASSNAME + ' w-[120px]'}
                    disabled={props.disabled}
                    type="Number"
                    onChange={onMinuteChange}
                    value={props.value[1]}
                />
                <div className='text-base ml-2'>{props.translate('minute(s)')}</div>
            </div>
        </div>
    )
}

export default HourlyCron;
